export class Controller {
    /**
     * Stores the options of the controller.
     *
     * @var {Object}
     */
    options;

    /**
     * Stores weather the controller has been binded yet.
     * @var {ScalerChartBuilder\undefined}
     */
    _scalerChartBuilder;

    /**
     * Creates a new instance.
     *
     * @param eventTarget The event targed used by the controller.
     */
    constructor(options) {
        this.options = {
            eventTarget: new EventTarget(),
            destroyWhenDetached: true,
            ...options,
        };
    }

    /**
     * Attaches the current controller into the given ScalerChartBuilder instance.
     *
     * @param ScalerChartBuilder
     * @throws
     */
    attach(scalerChartBuilder) {
        this.detach();
        this._scalerChartBuilder = scalerChartBuilder;
        this.options.onAttach?.(scalerChartBuilder, this);
    }

    /**
     * Detaches any active instance from the controller.
     */
    detach() {
        if (this.options.destroyWhenDetached) this._scalerChartBuilder?.delete();
        this._scalerChartBuilder = undefined;
    }

    /**
     * Determines if the controller is currently attached.
     *
     * @returns {boolean}
     */
    isAttached() {
        return this._scalerChartBuilder !== undefined;
    }

    /**
     * Creates the chart.
     *
     * @param detail
     */
    create(detail) {
        this.send('create', detail);
    }

    /**
     * Updates the chart.
     *
     * @param detail
     */
    update(detail) {
        this.send('update', detail);
    }

    /**
     * Deletes the chart.
     */
    delete() {
        this.send('delete');
    }

    /**
     * Manually subscribes to the given chart event.
     *
     * @param event
     * @param {Subscriber} listener
     * @returns Unsubscriber
     */
    on(event, listener) {
        this.options.eventTarget.addEventListener(event, listener);
        return () => this.options.eventTarget.removeEventListener(event, listener);
    }

    /**
     * Manually sends an event out.
     *
     * @param event
     * @param {any} detail
     */
    send(event, detail) {
        this.options.eventTarget.dispatchEvent(new CustomEvent(event, { detail }));
    }
}
